import { Component, OnInit } from "@angular/core";
import moment from "moment";
import { AppService } from "src/app/core/services/app.service";
import { ImageCropperService } from "src/app/core/services/image-cropper.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { OOMenuItem } from "src/app/shared/models/oo-menu-item";
import { OOMenuStatus } from "src/app/shared/models/oo-menu-status";

@Component({
	selector: "app-menu-item-setup",
	templateUrl: "./menu-item-setup.component.html",
	styleUrls: ["../../commandcenter.scss"],
})
export class MenuItemSetupComponent implements OnInit {
	loaded: boolean = false;

	menuItemSelected: OOMenuItem;
	menuSyncStatus: OOMenuStatus;
	menuSyncRecordsUpdated: string[];
	moment: any = moment;

	timestamp: number = new Date().getTime();

	constructor(public app: AppService, public imgCrop: ImageCropperService, public venueService: OOVenueService) {}

	ngOnInit(): void {}
}
